<template>
    <div class="making-our-brand-tangible-opener">
        <div class="section-opener">
            <div class="wrapper wrapper-small">
                <h2 class="major-heading">Making our <br />brand tangible</h2>
                <p>
                    Depending on the individual use case and context, there can be multiple ways to translate and
                    realize the Experience Principles. To create holistic high-quality experiences, we provide designers
                    and developers with effective guidance, tools and assets across all dimensions of our brand
                    expression.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'MakingOurBrandTangibleOpener',
        data() {
            return {};
        },
    };
</script>

<style scoped lang="scss">
    @keyframes anim-fade-in {
        from {
            transform: translateY(-20px);
            opacity: 0;
        }

        to {
            transform: translateY(0px);
            opacity: 1;
        }
    }

    @keyframes anim-fade-out {
        from {
            transform: translateY(0px);
            opacity: 1;
        }

        to {
            transform: translateY(20px);
            opacity: 0;
        }
    }
    .section-opener {
        margin: 0 auto;
        opacity: 0;
        text-align: center;
    }

    .active {
        &.on-leave {
            .section-opener {
                animation: anim-fade-out 0.3s forwards;
            }
        }
        .section-opener {
            animation: anim-fade-in 1s 0.7s forwards;
        }
    }
    .brand-category {
        width: calc(50% - #{spacing(12)});
        margin: 0px spacing(12);

        &:first-of-type {
            height: 100%;
            width: 100%;
            box-sizing: border-box;
            @include flex($justify-content: center, $align-items: center);

            .text-wrapper {
                width: 80%;
                text-align: center;

                @media (max-width: breakpoint('large')) {
                    width: 75%;
                }

                @media (max-width: breakpoint('medium')) {
                    width: 100%;
                }
            }
        }

        @media (max-width: breakpoint('large')) {
            width: calc(50% - #{spacing(6)});
            margin: 0px spacing(6);
        }

        @media (max-width: breakpoint('medium')) {
            width: 100%;
            margin: 0;
        }
    }

    .brand-category-number {
        font-size: 21px;
        font-weight: font-weight('thin');
        margin-bottom: spacing(3);
    }

    .brand-category-heading {
        margin-bottom: spacing(3);
    }

    .brand-category-description {
        font-size: 16px;
    }

    .brand-category-image {
        @include reset-img();
        margin-bottom: spacing(2);
        width: 55%;
        margin-left: auto;
        margin-right: auto;

        @media (max-width: breakpoint('medium')) {
            width: 250px;
        }

        @media (max-width: breakpoint('small')) {
            width: 200px;
        }
    }

    .custom-cursor-trigger-zone {
        top: 0;
        position: absolute;
        height: 100%;
        width: 50%;

        &.has-full-width {
            width: 100%;
        }

        &.is-hidden {
            width: 0%;
        }

        &.cc-arrow-left {
            left: 0;
        }

        &.cc-arrow-right {
            right: 0;
        }
    }
</style>
